import type { BeginnerPathPhaseId } from "./beginnerPathPlan";

export const BEGINNER_PATH_QUERY_FROM = "from";
export const BEGINNER_PATH_QUERY_PHASE = "phase";
export const BEGINNER_PATH_FROM_VALUE = "path";

export function beginnerPathUrl(path: string, phaseId: BeginnerPathPhaseId): string {
  const base = path.split("?")[0];
  const params = new URLSearchParams();
  params.set(BEGINNER_PATH_QUERY_FROM, BEGINNER_PATH_FROM_VALUE);
  params.set(BEGINNER_PATH_QUERY_PHASE, phaseId);
  return `${base}?${params.toString()}`;
}

export function isBeginnerPathEntry(
  search: string
): { fromPath: boolean; phaseId: BeginnerPathPhaseId | null } {
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  const fromPath = params.get(BEGINNER_PATH_QUERY_FROM) === BEGINNER_PATH_FROM_VALUE;
  const raw = params.get(BEGINNER_PATH_QUERY_PHASE);
  const phaseId = raw as BeginnerPathPhaseId | null;
  return { fromPath, phaseId };
}
